import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Carga } from 'src/app/models/cml/carga/carga';
import { PedidoVenda } from 'src/app/models/cml/pedido-venda/pedido-venda';
import { NotaFiscal } from 'src/app/models/fat/nota-fiscal/nota-fiscal';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotaFiscalService extends AbstractIdbaService {

  constructor(http: HttpClient) {
    super(http);
    this.programName = "fat/notafiscal/notafiscal.p";
  }

  override listarTodos() {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-listar';
    request.parameters = {};
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  /*donwloadDanfe(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-download-danfe';
    request.parameters = { registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }*/

  donwloadDanfe(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-download-danfe';
    request.parameters = { rowid: registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  donwloadBoleto(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-download-boleto';
    request.parameters = { rowid: registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  donwloadCartaCorrecao(codigoDocumento) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-download-carta-correcao';
    request.parameters = { codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  downloadXML(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-download-xml';
    request.parameters = { rowid: registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  consultarSefaz(registro: NotaFiscal) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/notafiscal.p";
    request.procedure = 'pi-retorno-sefaz';
    request.parameters = { codigoDocumento: registro.codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  reenviarNota(registro: NotaFiscal) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/notafiscal.p";
    request.procedure = 'pi-emitir-nota-fiscal';
    request.parameters = { codigoDocumento: registro.codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  atualizarMovimentos(registro: NotaFiscal) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/documentoevento/documentoevento.p";
    request.procedure = 'pi-pesquisar-por-documento';
    request.parameters = { codigoDocumento: registro.codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  faturarCarga(registro: Carga) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-incluir';
    request.parameters = { codigoCarga: registro.codigoCarga };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  faturarPedido(registro: PedidoVenda) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-incluir';
    request.parameters = { codigoPedido: registro.codigoPedido };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  listaNotaMonitor(param: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-lista-notas-monitor';
    delete param.documentoSerie
    delete param.local
    delete param.portador
    delete param.situacaoDocumento
    delete param.cliente
    request.parameters = { ...param };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  cancelarNotaFiscal(codigoDocumento: number, cancelamento: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-cancelar-nota-fiscal';
    request.parameters = { codigoDocumento, justificativa: cancelamento.justificativa, idMotivoCancelamento: cancelamento.idMotivoCancelamento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  buscarCartaCorrecao(codigoDocumento: number) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-buscar-carta-correcao';
    request.parameters = { codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  enviarCartaCorrecao(codigoDocumento: number, cartaCorrecao: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-enviar-carta-correcao';
    request.parameters = { codigoDocumento, cartaCorrecao };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  pesquisaEventosNotaFiscal(codigoDocumento: number) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/documentoevento/documentoevento.p";
    request.procedure = 'pi-pesquisar-por-documento';
    request.parameters = { codigoDocumento };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  enviarEmailAnexos(registro: NotaFiscal) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-envia-email-faturamento';
    request.parameters = { rowid: registro.rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  listaDetalheNota(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "fat/notafiscal/monitornotafiscal.p";
    request.procedure = 'pi-lista-detalhe-nota';
    request.parameters = { rowid: registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }
}
